// Actions
import { CheckoutActionTypes, CheckoutActions } from './checkout.actions';
import { CheckoutState } from './checkout.state';

// Models

const defaultState: CheckoutState = {
    alertsShowed: {},
};

export type Action = CheckoutActions;

export function CheckoutReducer(state = defaultState, action: any) {
    // console.log(state, action);
    switch (action.type) {
        case CheckoutActionTypes.DO_SET_ALERTS_SHOWED:
            // console.log(state, action);
            return {
                ...state,
                alertsShowed: { ...action.payload.alertsShowed },
            };

        default:
            return state;
    }
}
